export default __webpack_public_path__ + "static/media/fifa_group.46ad559f.png";